module.exports = __webpack_public_path__ + "img/close.c3bf328c.svg";